import { useState,useEffect } from "react";
import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Checkbox } from "../ui/checkbox";

import Happy from "./Happy.png";
import Neutral from "./Neutral.png";
import Unhappy from "./Unhappy.png";

import { hooks } from "botframework-webchat-component";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const { useSendEvent } = hooks;

const HappinessCardArabic = ({setScript,id,surveyData,disableSend}) => {
  const sendEvent = useSendEvent();
  const [selectedFeedback, setSelectedFeedback] = useState(null); // Track selected feedback
  const [expanded, setExpanded] = useState(false); // Track if the card is expanded
  const [showComments, setShowComments] = useState(false); // Track if the comments section should be displayed
  const [comments, setComments] = useState(""); // Track user comments
  const [readOnly, setReadOnly] = useState(false); // Track whether the form is read-only

  const feedbackOptions = {
    happy: [
      { id: "1", label: "مظهر وتصميم رمّاس"},
      { id: "2", label: "سهولة الحصول على المعلومات عن طريق رمّاس"},
      { id: "3", label: "دقة ووضوح المعلومات" },
      { id: "4", label: "ملائمة القوائم في رمّاس"},
      { id: "5", label: "سرعة استجابة رمّاس" },
    ],
    neutral: [
      { id: "1", label: "مظهر وتصميم رمّاس"},
      { id: "2", label: "سهولة الحصول على المعلومات عن طريق رمّاس"},
      { id: "3", label: "دقة ووضوح المعلومات" },
      { id: "4", label: "ملائمة القوائم في رمّاس"},
      { id: "5", label: "سرعة استجابة رمّاس" },
    ],
    unhappy: [
      { id: "1", label: "مظهر وتصميم رمّاس"},
      { id: "2", label: "سهولة الحصول على المعلومات عن طريق رمّاس"},
      { id: "3", label: "دقة ووضوح المعلومات" },
      { id: "4", label: "ملائمة القوائم في رمّاس"},
      { id: "5", label: "سرعة استجابة رمّاس" },
    ],
  };

  const handleSubmit = (feedback) => {
    setSelectedFeedback(feedback);
    setExpanded(true);
    let visibleScript = `للمقياس السعادة، لقد اخترت ${feedback}. ما الذي جعلك تشعر بهذه الطريقة؟ يرجى الاختيار من الخيارات التالية:`;

    setScript(visibleScript);
  };

  const FormSchema = z.object({
    items: z.array(z.string()).refine((value) => value.some((item) => item), {
      message: "يجب عليك اختيار خيار واحد على الأقل.",
    }),
  });

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      items: [],
    },
  });
  useEffect(() => {

    if (surveyData) {
      const { feedback, comments, selectedOptions } = surveyData;

      setSelectedFeedback(feedback);
      setComments(comments);
      setExpanded(true);


      form.setValue("items", selectedOptions);
      setReadOnly(true);


    }
  }, [id, form,surveyData]);
  function handleFinish() {
    const formData = form.getValues();
    const dataToSubmit = {
      feedback: selectedFeedback,
      selectedOptions: formData.items,
      comments,
    };
    const senddata = {
      id:id,
data:dataToSubmit
    }

    console.log("Submitting Data: ", senddata);
    sendEvent("submitFeedback", senddata);
    setReadOnly(true);
  }
  const isMobile = window.innerWidth <= 1000;  // Check if the screen size is mobile

  useEffect(() => {
    const feedbackTranslationMap = {
      happy: "سعيد",
      neutral: "محايد",
      unhappy: "غير سعيد",
    };
    let visibleText = "مقياس السعادة: كيف كانت تجربتك مع رمّاس؟ سعيد. محايد. غير سعيد.";
    if (readOnly) {
      visibleText = `للمقياس السعادة حيث الخيارات هي سعيد، محايد، وغير سعيد، لقد اخترت ${feedbackTranslationMap[selectedFeedback]}.`;
      if (selectedFeedback && form.getValues("items").length > 0) {
        const selectedIds = form.getValues("items");
        const selectedLabels = selectedIds
          .map((id) => {
            const option = feedbackOptions[selectedFeedback].find((item) => item.id === id);
            return option ? option.label : null;
          })
          .filter(Boolean);

        visibleText += ` لقد اخترت الخيارات التالية: ${selectedLabels.join(", ")} .`;
      }
      if (comments) {
        visibleText += ` لقد شاركت التعليقات التالية: \"${comments}\".... اضغط لإخفاء التعليقات.`;
      }
      visibleText += " شكرًا لمساهمتك.";
    } else {
      if (selectedFeedback) {
        visibleText = `للمقياس السعادة حيث الخيارات هي سعيد، محايد، وغير سعيد، لقد اخترت ${feedbackTranslationMap[selectedFeedback]}.`;
      }

      if (selectedFeedback && form.getValues("items").length === 0) {
        const options = feedbackOptions[selectedFeedback];
        const labels = options.map((option) => option.label).join(", ");
        visibleText += ` ما الذي جعلك تشعر بهذه الطريقة؟ يرجى الاختيار من الخيارات التالية: ${labels} `;
      }
      if (selectedFeedback && form.getValues("items").length > 0) {
        const options = feedbackOptions[selectedFeedback];
        const selectedIds = form.getValues("items");
        const selectedLabels = selectedIds
          .map((id) => {
            const option = feedbackOptions[selectedFeedback].find((item) => item.id === id);
            return option ? option.label : null;
          })
          .filter(Boolean);
          visibleText += ` لقد اخترت الخيارات التالية: ${selectedLabels.join(", ")} .`;

      }

      if (showComments && comments === "") {
        visibleText += `هل ترغب في تقديم مزيد من التعليقات؟ يرجى إدخال تعليقك.... اضغط لإخفاء التعليق.`;
      }

      if (showComments && comments) {
        visibleText += ` لقد شاركت التعليقات التالية: \"${comments}\".... اضغط لإخفاء التعليق.`;
      }

      if (selectedFeedback) {
        if (!showComments) {
          visibleText += `...اضغط لمشاركة التعليقات.`;
        }
        visibleText += " ...اضغط للإنهاء.";
      }
    }

    setScript(visibleText);
    console.log("HappinessCardArabic - Script Updated: ", visibleText);
  }, [selectedFeedback, showComments, form.getValues("items"), comments, readOnly]);

  return (
    <Card className="border-none">
      <CardHeader>
        <CardTitle>مقياس السعادة</CardTitle>
        <CardDescription>كيف كانت تجربتك مع رماس؟</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6">
      <div className="grid grid-cols-3 gap-4 text-center">
      <div>
    <Button
      onClick={() => handleSubmit("happy")}
      className={`p-0 bg-transparent hover:bg-transparent border-0 flex flex-col items-center justify-center ${
        isMobile ? "w-[4rem] h-[4rem]" : "w-24 h-24"
      }`}
      disabled={readOnly}
    >
      <img
        src={Happy}
        alt="سعيد"
        className={`object-contain filter ${
          isMobile ? "w-[3rem] h-[3rem]" : "w-16 h-16"
        } ${
          selectedFeedback === "happy"
            ? "grayscale-0 contrast-100"
            : "grayscale contrast-0 hover:grayscale-0 hover:contrast-100"
        } transition-all duration-300`}
      />
    </Button>
    <p className="mt-2">سعيد</p>
  </div>
  <div>
    <Button
      onClick={() => handleSubmit("neutral")}
      className={`p-0 bg-transparent hover:bg-transparent border-0 flex flex-col items-center justify-center ${
        isMobile ? "w-[4rem] h-[4rem]" : "w-24 h-24"
      }`}
      disabled={readOnly}
    >
      <img
        src={Neutral}
        alt="محايد"
        className={`object-contain filter ${
          isMobile ? "w-[3rem] h-[3rem]" : "w-16 h-16"
        } ${
          selectedFeedback === "neutral"
            ? "grayscale-0 contrast-100"
            : "grayscale contrast-0 hover:grayscale-0 hover:contrast-100"
        } transition-all duration-300`}
      />
    </Button>
    <p className="mt-2">محايد</p>
  </div>

  <div>
    <Button
      onClick={() => handleSubmit("unhappy")}
      className={`p-0 bg-transparent hover:bg-transparent border-0 flex flex-col items-center justify-center ${
        isMobile ? "w-[4rem] h-[4rem]" : "w-24 h-24"
      }`}
      disabled={readOnly}
    >
      <img
        src={Unhappy}
        alt="غير سعيد"
        className={`object-contain filter ${
          isMobile ? "w-[3rem] h-[3rem]" : "w-16 h-16"
        } ${
          selectedFeedback === "unhappy"
            ? "grayscale-0 contrast-100"
            : "grayscale contrast-0 hover:grayscale-0 hover:contrast-100"
        } transition-all duration-300`}
      />
    </Button>
    <p className="mt-2">غير سعيد</p>
  </div>
</div>

        {expanded && (
          <Form {...form}>
            <form onSubmit={form.handleSubmit(handleFinish)} className="space-y-8">
              <FormField
                control={form.control}
                name="items"
                render={() => (
                  <FormItem>
                    <div className="mb-4">
                      <FormLabel className="text-base">
                      إختر واحدا أو أكثر من القائمة أدناه ثم إضغط على إنتهاء
                      </FormLabel>
                    </div>
                    {feedbackOptions[selectedFeedback].map((item) => (
                      <FormField
                        key={item.id}
                        control={form.control}
                        name="items"
                        render={({ field }) => (
                          <FormItem
                            key={item.id}
                            className="flex flex-row items-start space-x-3 space-y-0"
                          >
                            <FormControl>
                              <Checkbox
                                className="ml-2 mt-1"
                                checked={field.value?.includes(item.id)}
                                onCheckedChange={(checked) => {
                                  if (!readOnly) {
                                    return checked
                                      ? field.onChange([...field.value, item.id])
                                      : field.onChange(
                                          field.value?.filter(
                                            (value) => value !== item.id
                                          )
                                        );
                                  }
                                }}
                                disabled={readOnly}
                              />
                            </FormControl>
                            <FormLabel className="text-sm font-normal">
                              {item.label}
                            </FormLabel>
                          </FormItem>
                        )}
                      />
                    ))}
                    <FormMessage />
                  </FormItem>
                )}
              />
              {showComments && (
                <div>
                  <label htmlFor="comments" className="text-sm font-normal">
                  أكتب ملاحظاتك
                  </label>
                  <textarea
                    id="comments"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    className="w-full p-2 mt-2 border rounded"
                    placeholder="أكتب ملاحظاتك"
                    disabled={readOnly}
                  />
                </div>
              )}
            </form>
          </Form>
        )}
      </CardContent>
      {selectedFeedback && !readOnly && (
        <CardFooter className="flex justify-between">
          <Button className="w-1/2 ml-2" onClick={() => setShowComments(!showComments)}>
            {showComments ? "إخفاء التعليقات" :"أخبرنا المزيد"}
          </Button>
          <Button className="w-1/2" disable={disableSend} onClick={handleFinish}>
          إنتهاء
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};

export default HappinessCardArabic;
